var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manual-create-game-lobby"},[_c('div',{staticClass:"manual-create-game-lobby__header"},[_vm._t("header")],2),_c('div',{staticClass:"manual-create-game-lobby__body"},[_vm._t("body")],2),_c('div',{staticClass:"manual-create-game-lobby__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }